export function getMicSensitivity(state) {
  return state.babyStation.micSensitivity;
}

export function getMotionSensitivity(state) {
  return state.babyStation.motionSensitivity;
}

export function getMicSensitivityCorrection(state) {
  return state.babyStation.micSensitivityCorrection;
}
